import { render, staticRenderFns } from "./Success.vue?vue&type=template&id=394339f9&"
var script = {}
import style0 from "./Success.vue?vue&type=style&index=0&id=394339f9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports